import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import type { FeatureKey } from '@riverpark/types'
import { useAuth } from '@/hooks/use-auth'
import { homePathForRole } from '@/lib/auth'

/** Wraps a single route's element (not a whole role section — ProtectedRoute already handles
 * that) and redirects home if an admin has turned this feature off for the current user, same
 * as ProtectedRoute's own role-mismatch redirect (no separate "feature disabled" messaging). */
export function FeatureGate({ feature, children }: { feature: FeatureKey; children: ReactNode }) {
  const { user } = useAuth()
  if (user && user.featureAccess[feature] === false) {
    return <Navigate to={homePathForRole(user.role)} replace />
  }
  return <>{children}</>
}
